import React from 'react'

import { RoundedRectangle } from '@/components/Icons/Shapes/RoundedRectangle.tsx'
import { cn } from '@/utils/common'

interface PointerBubbleShellProps {
  children: React.ReactNode
  className?: string
  size?: number
}

export const PointerBubbleShell: React.FC<PointerBubbleShellProps> = ({
  children,
  className,
  size = 40,
}) => {
  return (
    <div
      className={cn(
        'relative inline-flex items-center justify-center bg-transparent border-none'
      )}
      style={{ width: size, height: size }}
    >
      <RoundedRectangle className={cn('absolute', `w-10 h-10`, className)} />

      <div className="absolute flex items-center justify-center">
        {children}
      </div>
    </div>
  )
}
